/**
 * @generated SignedSource<<3a0bb0032008e7bef58bab48d55abfef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleFurtherReadingWidgetArticle$data = {
  readonly moreOnThisArticles: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"articleWidgetContent">;
  } | null | undefined> | null | undefined;
  readonly sponsorType: string | null | undefined;
  readonly " $fragmentType": "articleFurtherReadingWidgetArticle";
};
export type articleFurtherReadingWidgetArticle$key = {
  readonly " $data"?: articleFurtherReadingWidgetArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleFurtherReadingWidgetArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleFurtherReadingWidgetArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "moreOnThisArticles",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "articleWidgetContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "0f72bbbca83057f20e9f8751a6cc7447";

export default node;
